export default __webpack_public_path__ + "static/team4-f8c348d03d89e9ed7615cd7ef7c4063f.png";